import Calendar_Main from "../components/Calendar/Calendar_Main"

import React from 'react';
function Calendar() {

  return (<Calendar_Main/>);
}

export default Calendar;